<template>
  <div class="auth-box lock-screen-box">
    <!-- Start row -->
    <div class="row no-gutters align-items-center justify-content-center" v-if="isMounted">
      <!-- Start col -->
      <div class="col-md-6 col-lg-5">
        <!-- Start Auth Box -->
        <div class="auth-box-right">
          <div class="card">
            <div class="card-body">
              <div class="form-head">
                <img :src="mainLogo" class="img-fluid" alt="logo">
              </div> 
              <h4 class="text-primary my-4">¡Bienvenido a Mi Brime!</h4>
              <p class="mb-4">Aplicación para ventas a clientes.</p>
              <div class="user-logo mb-4">
                  <img :src="userIcon" class="rounded-circle img-fluid" alt="user-img">
              </div>
              <button type="submit" class="btn btn-success btn-lg btn-block font-18 mb-2" @click.stop="goToLoginPage">Iniciar sesión</button>
              <!--p class="mb-0 mt-3">¿No tienes una cuenta? <router-link :to="{ name: 'login'}">Clic aquí.</router-link></p-->
            </div>
          </div>
        </div>
        <!-- End Auth Box -->
      </div>
      <!-- End col -->
    </div>
    <!-- End row -->
  </div>
</template>

<script>

import { mapState } from 'vuex';
export default {
  name: 'Home',
  data(){
    return {
      mainLogo: require('@assets/images/logos/mid-logo.png'),
      userIcon: require('@assets/images/users/boy.svg'),
      isMounted: false
    }
  },
  computed: {
    ...mapState("auth", ["user", "is_logged"]),
  },
  beforeMount(){
    this.isMounted = false
    if(this.is_logged == true && this.user != null){
      this.$router.replace('cliente');
    }
    else {
      this.isMounted = true
    }
  },
  methods: {
    async goToLoginPage(){
      this.$router.push({name: 'login'});
    },
  },
}
</script>
